import { Injectable } from '@angular/core';
import {NgxUiLoaderService} from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  constructor(private loader: NgxUiLoaderService,) {}
  start() {
    this.loader.start();
  }
  stop() {
    this.loader.stop();
  }
}
